module.exports = __webpack_public_path__ + "static/media/7.57f4b54b.jpg";